import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { useNotificationCenterRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { DashboardActivitySections } from "web_myplann/Dashboard/Components/DashboardActivitySections";
import { DashboardNotificationsSection } from "web_myplann/Dashboard/Components/DashboardNotificationsSection";
import { DashboardShell } from "web_myplann/Dashboard/Components/DashboardShell";
import { FinancialBalanceV2 } from "web_myplann/Dashboard/Components/FinancialBalanceV2";
import { InspirationSection } from "web_myplann/Dashboard/Components/InspirationSection";
import { QuickCalculatorsSection } from "web_myplann/Dashboard/Components/QuickCalculatorsSection";

export const DashboardV2Page: FC = () => {
	const theme = useTheme();
	const hasNotificationCenterRight = useNotificationCenterRightOptional();

	return (
		<DashboardShell background={theme.palette.surface.muted} showTopGlow>
			<Stack gap={0.8} pt={0.8} pb={2}>
				{hasNotificationCenterRight ? (
					<DashboardNotificationsSection />
				) : (
					<DashboardActivitySections />
				)}
				<FinancialBalanceV2 />
				<InspirationSection />
				<QuickCalculatorsSection />
			</Stack>
		</DashboardShell>
	);
};
